import { render, staticRenderFns } from "./comunicadosEdit.vue?vue&type=template&id=f3cdc0ca&"
import script from "./comunicadosEdit.vue?vue&type=script&lang=js&"
export * from "./comunicadosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports